/**
 * AuthProviderFactory
 * Factory for creating auth provider instances
 */

import type { IAuthProvider } from '@/core/interfaces'
import { MockAuthProvider } from './MockAuthProvider'

export type AuthProviderType = 'mock' | 'api'

export interface AuthProviderConfig {
  apiUrl?: string
  apiKey?: string
}

export class AuthProviderFactory {
  /**
   * Create an auth provider instance
   * @param type - Provider type
   * @param config - Optional configuration
   * @returns IAuthProvider instance
   */
  static create(
    type: AuthProviderType = 'mock',
    _config?: AuthProviderConfig,
  ): IAuthProvider {
    switch (type) {
      case 'mock':
        return new MockAuthProvider()

      case 'api':
        // TODO: Implement APIAuthProvider when backend is ready
        throw new Error('API auth provider not yet implemented')

      default:
        throw new Error(`Unknown auth provider type: ${type}`)
    }
  }

  /**
   * Create provider based on environment
   * @returns IAuthProvider instance
   */
  static createFromEnvironment(): IAuthProvider {
    const env = import.meta.env.MODE

    if (env === 'development' || env === 'test') {
      return AuthProviderFactory.create('mock')
    }

    // In production, we'd use API provider
    // For now, fallback to mock
    return AuthProviderFactory.create('mock')
  }
}
